<div [formGroup]="form">
  <div
    class="repeatable-card-field"
    *ngFor="let tag of tags; let i = index">
    <mat-form-field>
      <input
        matInput
        [formControlName]="i"
        [placeholder]="'Aggiungi tag' | translate">
    </mat-form-field>

    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-raised-button
      type="button"
      (click)="removeTagHandler(i)">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    class="tag-action"
    (click)="addTagHandler()">
    {{ 'Aggiungi tag' | translate }}
  </button>
</div>
